<template>
  <div class="wedge" v-if="active">
    <div class="wedge__rows uk-text-center" :class="'wedge__rows--'+params.orientation">
      <div class="wedge__row" v-for="row in rows" :key="row.id">
        <div class="wedge__left">{{ row.left }}</div>
        <div class="wedge__dots">{{ row.dots }}</div>
        <div class="wedge__index">{{ row.index }}</div>
        <div class="wedge__dots">{{ row.dots }}</div>
        <div class="wedge__right">{{ row.right }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['params', 'http'],
  name: "game_body",
  //mixins: [ soundMix ],
  data() {
    return {
      time_timer: '',
      time: {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        total_ms: 0
      },
      arrow_step: '',
      rows: []
    }
  },
  props: {
    items: '',
    active: ''
  },
  watch: {
    active: 'checkFinish'
  },
  computed: {
    timerSpeed() {
      return 60 / this.params.bpm * 1000;
    },
    seconds_count() {
      return this.time.total_ms / 1000;
    }
  },
  methods: {
    async startApp() {
      console.log('start app');
      let elements = await this.getAroundElements();
      this.rows = this.makeRows(elements);
      //this.startTimeTimer();
    },

    // Получаем элементы по краям
    getAroundElements() {
      if (this.params.mode === 'digits') return this.getDigits();
      if (this.params.mode === 'words') return this.getWords();
    },

    // Получаем цифры
    getDigits() {
      let digits_array = [];
      for (let i = 0; i < this.params.rows; i++) {
        digits_array.push({
          'left': this.getDigit(),
          'right': this.getDigit(),
        });
      }
      return digits_array;
    },

    // Получаем цифру
    getDigit() {
      let qnt = this.params.digits_count;
      let min = Math.pow(10, qnt) - 1;
      let max = Math.pow(10, qnt - 1);
      return this.randomInteger(min, max);
    },

    // Получаем слова
    async getWords() {
      let words = await this.http.get(window.location.origin + `/api/get-words/${this.params.letters_count}/${this.params.rows}`).then(res => res.data);

      let words_array = [];
      for (let i = 0; i < this.params.rows; i++) {
        let word = this.getWord(words[i].word);
        words_array.push({
          'left': word[0].join(''),
          'right': word[1].join(''),
        });
      }
      return words_array;
    },

    // Получаем слово
    getWord(word) {
      let length = word.length;
      return _.chunk(word, length / 2);
    },

    makeString(arr) {
      return arr.join('');
    },

    makeRows(elements) {
      let rows = [];
      elements.forEach((item, index) => {
        let orient = this.params.orientation;
        let qnt = orient === 'row' ? 1 * (index + 1) : (3 * (index + 1));
        let dot = orient === 'row' ? '·' : '.'
        let dots = _.fill(new Array(qnt), dot).join('');

        rows.push({
          'left': item.left,
          'dots': dots,
          'index': index + 1,
          'right': item.right
        });
      });
      return rows;
    },

    // Генерируем случайное число
    randomInteger(min, max) {
      let rand = min + Math.random() * (max + 1 - min);
      return Math.floor(rand);
    },


    startTimeTimer() {
      let duration = moment.duration({
        'seconds': 0,
      });
      this.time_timer = setInterval(() => {
        duration = moment.duration(duration.asSeconds() + 1, 'seconds');
        this.time = duration._data;
        this.time.total_ms = duration._milliseconds;
      }, 1000);
    },


    stopTimers() {
      clearInterval(this.time_timer);
    },

    checkFinish() {
      if (!this.active) {
        this.onFinish();
      } else {
        this.startApp();
      }
    },

    onFinish() {
      console.log('on finish');
      this.stopTimers();
      this.$emit('onFinish', this.time);
    }
  },
  mounted() {
    //this.startApp();
  },
  beforeDestroy() {
    this.stopTimers();
  }
}
</script>